import { Drag } from "neetoicons";

const DragHandle = props => (
  <div
    className="neeto-ui-text-gray-500 flex h-8 flex-shrink-0 cursor-grab items-center"
    data-testid="drag-handle"
    {...props}
  >
    <Drag
      className="neeto-ui-text-gray-400 hover:neeto-ui-text-gray-500 transition-all duration-300 ease-in-out"
      size={16}
    />
  </div>
);

export default DragHandle;
